/**
 * @function getDateHourMinute
 * @description Convertit une date en heure et minute (HH:MM).
 * @param {Date | string | number} date - Date à convertir.
 * @returns {string} Heure et minutes sous forme de chaîne "HH:MM".
 */
export const getDateHourMinute = (date: any) => {
  const dateValue = new Date(date);
  const hour = dateValue.getHours().toString().padStart(2, '0');
  const min = dateValue.getMinutes().toString().padStart(2, '0');

  return `${hour}:${min}`;
};

/**
 * @function getDateFormat
 * @description Formate une date en "jour mois année", par exemple "05 Novembre 2025".
 * @param {Date | string | number} date - Date à formater.
 * @returns {string} Date formatée.
 */
export const getDateFormat = (date: any) => {
  const dateValue = new Date(date);

  const day = dateValue.getDate().toString().padStart(2, '0');
  const year = dateValue.getFullYear();

  const months = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];

  const month = months[dateValue.getMonth()];

  return `${day} ${month} ${year}`;
};
